import axiosClient from "./axiosClient";

export interface CreateBatchPayload {
    paymentIds: number[];
    batchName?: string;
}

export interface ReconcileItem {
    paymentId: number;
    batchStatus: "ok" | "hold" | "error";
    note?: string;
}

const batchPaymentApi = {
    getAll(query?: string) {
        return axiosClient.get(`/payment/batch?${query || ""}`);
    },
    create(data: CreateBatchPayload) {
        return axiosClient.post("/payment/batch", data);
    },
    getById(id: number) {
        return axiosClient.get(`/payment/batch/${id}`);
    },
    /** type: "mixed" (default) | "reconcile" */
    exportXlsx(id: number, type: "mixed" | "reconcile" = "mixed") {
        return axiosClient.post(`/payment/batch/${id}/export?type=${type}`, {}, { responseType: "blob" });
    },
    reconcile(id: number, items: ReconcileItem[]) {
        return axiosClient.post(`/payment/batch/${id}/reconcile`, { items });
    },
    complete(id: number) {
        return axiosClient.post(`/payment/batch/${id}/complete`);
    },
    /** Gỡ 1 lệnh khỏi lô → về hàng chờ. Backend chỉ cho gỡ dòng HOLD/ERROR. */
    detachItem(id: number, paymentId: number) {
        return axiosClient.delete(`/payment/batch/${id}/items/${paymentId}`);
    },
    /** cancelReason bắt buộc — backend từ chối nếu để trống */
    cancel(id: number, cancelReason: string) {
        return axiosClient.delete(`/payment/batch/${id}`, { data: { cancelReason } });
    },
    purge(id: number) {
        return axiosClient.delete(`/payment/batch/${id}/purge`);
    },
};

export default batchPaymentApi;
